export const REGISTER_PAGE_PATH = "/travel/user-auth/#user-register/";

export const ACCESS_WITHOUT_ACCOUNT_PATH = "/travel/secure/#mytripslogin/";
export const ACCESS_WITHOUT_ACCOUNT_PATH_SUPPORT_AREA =
  "/travel/secure/#mytripslogin/actions=opensa";

export const MEMBERSHIP_REACTIVATION =
  "/travel/membership-pages/#membership_mytrips_reactivation/";
